export enum FetchStatus {
  'none',
  'loading',
  'error',
  'done'
}
